import { Backdrop, Card, CardContent, CardHeader, CircularProgress, Container, Divider, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, TablePagination, Tooltip, InputAdornment, Autocomplete, TextField, Box, Stack } from '@mui/material';
import Alert from 'src/components/Alert';
import React, { useEffect, useMemo, useState } from 'react';
import Page from 'src/components/Page';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import BlockIcon from '@mui/icons-material/Block';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from 'react-router';
import CloseIcon from '@mui/icons-material/Close';
import Tarihce from 'src/views/History';
import ListItemButton from '@mui/material/ListItemButton';
import FolderIcon from '@mui/icons-material/Folder';
import ExpandableComment from 'src/components/ExpandableComment';

const styles = {
    root: (theme) => ({
        paddingTop: theme.spacing(3),
        paddingBottom: theme.spacing(3)
    }),
    softDanger: {
        backgroundColor: 'rgba(211, 47, 47, 0.12)',
        color: '#c62828',
        boxShadow: 'none',
        '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.22)', boxShadow: 'none' }
    },
    softSuccess: {
        backgroundColor: 'rgba(46, 125, 50, 0.12)',
        color: '#2e7d32',
        boxShadow: 'none',
        '&:hover': { backgroundColor: 'rgba(46, 125, 50, 0.22)', boxShadow: 'none' }
    },
    rootlist: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 550,
    }),
    rootlistsag: (theme) => ({
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        position: 'relative',
        overflow: 'auto',
        maxHeight: 500,
    }),

    cardBolum: {
        maxHeight: 700,
        minHeight: 700,
        width: '100%'
    },
    table: {
        minWidth: 650,
    },
    content: {
        minHeight: 550,
    },
    chatSection: {
        width: '100%',
    },
    container: {
        maxHeight: '100%',
        maxWidth: '100%',
        minWidth: '100%'
    },
    container1: {
        maxHeight: 630,
        maxWidth: '100%',
        minWidth: '100%'
    },
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40
    },
    headBG: {
        backgroundColor: '#e0e0e0'
    },
    borderRight500: {
        borderRight: '1px solid #e0e0e0'
    },
    messageArea: {
        overflowY: 'auto'
    },
    button: (theme) => ({
        margin: theme.spacing(1),
    }),
    backdrop: {
        zIndex: 1500,
        color: '#fff'
    },
    closeButton: (theme) => ({
        position: 'absolute',
        right: theme.spacing(0),
        top: theme.spacing(-1),
        color: theme.palette.grey[500],
    }),
    formControl: (theme) => ({
        margin: theme.spacing(3)
    }),
    cardscontent3: {
        minHeight: 50
    },
    cardscontent2: {
        height: 600
    },
    spanText: {
        lineHeight: 2,
        fontFamily: 'Roboto',
        fontSize: 14
    },
    textInput: {
        border: 'none',
        borderBottom: '1px solid #1890ff',
        padding: '2px 5px',
        outline: 'none',
        fontWeight: 'bold',
    },
    responsiveContainer: (theme) => ({
        [theme.breakpoints.between("md", "lg")]: {
            maxHeight: "70vh",
            overflowX: 'hidden',
            overflowY: 'scroll'
        },
        [theme.breakpoints.down("sm")]: {
            maxHeight: "60vh",
            overflow: 'scroll'
        }
    })
};

function OpenReject() {
    const [loading, setLoading] = useState(false);
    const [uyari, setUyari] = useState(false);
    const [uyariTip, setUyariTip] = React.useState('default');
    const [acilisTipId, setAcilisTipId] = useState(null)
    const [responseMessage, setresponseMessage] = useState({
        ErrorCode: '0',
        ErrorDescription: 'success_message'
    });
    const [tarihcePopUp, setTarihcePopUp] = useState(false);
    const [filePopUp, setFilePopUp] = useState(false);
    const [fileList, setFileList] = React.useState([])
    const uyariKapat = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUyari(false);
    };

    const [generalData, setGeneralData] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const SessionUser = getUser();
    const navigate = useNavigate();

    const [searchText, setSearchText] = useState('');
    const [filtreAcilisTipi, setFiltreAcilisTipi] = useState(null);
    const [filtreServisTipi, setFiltreServisTipi] = useState(null);
    const [filtreDurum, setFiltreDurum] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);

    const getDurumText = (row) => (row.DURUM_ID == 1 ? row.DURUM : row.SONRAKI_ADIM_ACIKLAMA);

    const acilisTipiSecenekleri = useMemo(() => (
        [...new Set(generalData.map((row) => row.ACILIS_TIP).filter(Boolean))]
    ), [generalData]);
    const servisTipiSecenekleri = useMemo(() => (
        [...new Set(generalData.map((row) => row.SERVIS_TIP).filter(Boolean))]
    ), [generalData]);
    const durumSecenekleri = useMemo(() => (
        [...new Set(generalData.map((row) => getDurumText(row)).filter(Boolean))]
    ), [generalData]);

    const filteredData = useMemo(() => {
        const arama = searchText.trim().toLocaleLowerCase('tr');
        return generalData.filter((row) => {
            if (filtreAcilisTipi && row.ACILIS_TIP !== filtreAcilisTipi) return false;
            if (filtreServisTipi && row.SERVIS_TIP !== filtreServisTipi) return false;
            if (filtreDurum && getDurumText(row) !== filtreDurum) return false;
            if (!arama) return true;
            const aranacakAlanlar = [row.ACILIS_TIP, getDurumText(row), row.IL_ILCE, row.SERVIS_TIP, row.SERVIS_BILGI, row.SERVIS_KONUMU, row.FINDEKS_YORUM];
            return aranacakAlanlar.some((alan) => alan?.toString().toLocaleLowerCase('tr').includes(arama));
        });
    }, [generalData, searchText, filtreAcilisTipi, filtreServisTipi, filtreDurum]);

    useEffect(() => {
        setPage(0);
    }, [searchText, filtreAcilisTipi, filtreServisTipi, filtreDurum]);

    const filtreleriTemizle = () => {
        setSearchText('');
        setFiltreAcilisTipi(null);
        setFiltreServisTipi(null);
        setFiltreDurum(null);
    };

    const filtreAktifMi = Boolean(searchText || filtreAcilisTipi || filtreServisTipi || filtreDurum);

    useEffect(() => {
        getRejectedOpeningList();
    }, []);


    const getRejectedOpeningList = () => {
        setLoading(true);
        axios.get(`/GetRejectedOpeningList/${SessionUser.TopServiceShopCode}`)
            .then((response) => {
                setLoading(false);
                const res = response.data;
                setGeneralData(res);
            }).catch(error => {
                setLoading(false);
            });
    };
    //Red butonu tıklanınca
    const handleRejectButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu reddedilecek ve "BY - Onay" durumuna dönecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, true);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });

    };

    //İptal butonu tıklanınca    
    const handleCancelButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu iptal edilecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, true);
                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    //Devam et butonu tıklanınca
    const handleConfirmButtonClicked = (id, durum) => {
        confirmAlert({
            message: 'Bu açılış başvurusu sürece tekrardan dahil edilecektir. Onaylıyor musunuz?',
            buttons: [
                {
                    label: 'Evet',
                    onClick: () => {
                        cancelOrConfirmBasvuru(id, durum, false);

                    }
                },
                {
                    label: 'Hayır',
                    onClick: () => {
                        return;
                    }
                }
            ]
        });
    };

    const cancelOrConfirmBasvuru = async (id, durum, cevap) => {
        const data = JSON.stringify({
            Id: id,
            Durum: durum,
            IsCancel: cevap,
            UserId: "" //okta
        });

        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        axios.post('CancelOrConfirmBasvuru', data, config).then((response) => {
            var res = response.data[0];
            if (res.ErrorCode == '1000') {
                setresponseMessage(res.ErrorDescription)
                setUyariTip("error");
                setUyari(true);
                setLoading(false);
            }
            if (res.ErrorCode == '0') {
                setresponseMessage(res.ErrorDescription)
                setUyariTip("success");
                setUyari(true);
                setLoading(false);
                getRejectedOpeningList();
                if (!cevap) {
                    navigate(`/confirm?id=${id}`);
                }
            }
        }).catch(error => {
            setLoading(false);
        });
    };
    const handleYorum = (row) => {
        setSelectedIndex(row.ID);
        setTarihcePopUp(true);
    };

    const handleFilePopUp = (row) => {
        setSelectedIndex(row.ID);
        getReceiptAllFiles(row.ID)
        setFilePopUp(true);
    };

    const getReceiptAllFiles = (receiptNumber) => {
        setFileList([]);
        setLoading(true);
        if (!receiptNumber) {
            return;
        }
        var images = []
        axios.get("/getReceiptAllFiles/" + receiptNumber + '/' + 1).then(response => {
            setFileList(Array.isArray(response.data) ? response.data : [])
            setLoading(false)
        });
    }
    const setNewWindowOpen = (item) => {
        //get file data from GetReceiptFilesSpecial api
        setLoading(true);
        axios.get(`/GetReceiptFilesSpecial/${item.DOSYA_ID}`)
            .then((response) => {
                const res = response.data[0];
                var FileData = `data:${res.DOSYA_TIPI};base64,${res.DOSYA_DATA}`
                if (res?.DOSYA_TIPI?.includes('image')) {
                    var image = new Image();
                    image.src = FileData;
                    var w = window.open("");
                    w.document.write(image.outerHTML);
                    w.document.title = res.DOSYA_ADI;
                    w.document.close();
                } else {
                    var blobData = base64ToBlob(res.DOSYA_DATA, "application/pdf");
                    openBlobInNewTab(blobData);
                }
                setLoading(false);
            }).catch(error => {
                setLoading(false);
            });

        // var FileData = `data:${item.DOSYA_TIPI};base64,${item.DOSYA_DATA}`
        // if (item?.DOSYA_TIPI?.includes('image')) {
        //     var image = new Image();
        //     image.src = FileData;
        //     var w = window.open("");
        //     w.document.write(image.outerHTML);
        //     w.document.title = item.DOSYA_ADI;
        //     w.document.close();
        // } else {
        //     var blobData = base64ToBlob(item.DOSYA_DATA, "application/pdf");
        //     openBlobInNewTab(blobData);
        // }
    }

    function base64ToBlob(base64Data, contentType) {
        var byteCharacters = atob(base64Data);
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: contentType });
    }
    function openBlobInNewTab(blobData) {
        var newTab = window.open();
        var objectUrl = URL.createObjectURL(blobData);
        newTab.document.write('<embed width="100%" height="100%" src="' + objectUrl + '" type="application/pdf"></embed>');
    }

    return (
        <Page sx={styles.root}>
            <Backdrop style={styles.backdrop} open={loading}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <Snackbar
                open={uyari}
                autoHideDuration={10000}
                onClose={uyariKapat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert
                    onClose={uyariKapat}
                    variant={uyariTip}
                    message={responseMessage}
                ></Alert>
            </Snackbar>
            <Container style={styles.container1} maxWidth="xl">
                <Card>
                    <CardHeader
                        title="Reddedilenler"
                        subheader={generalData.length ? `${filteredData.length} / ${generalData.length} kayıt` : undefined}
                    />
                    <Divider />
                    <CardContent>
                        <Grid container spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                <TextField
                                    size="small"
                                    fullWidth
                                    label="Ara"
                                    placeholder="İl/ilçe, servis bilgisi..."
                                    value={searchText}
                                    onChange={(event) => setSearchText(event.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon fontSize="small" />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                <Autocomplete
                                    size="small"
                                    options={acilisTipiSecenekleri}
                                    value={filtreAcilisTipi}
                                    onChange={(event, value) => setFiltreAcilisTipi(value)}
                                    renderInput={(params) => <TextField {...params} label="Açılış Tipi" />}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                <Autocomplete
                                    size="small"
                                    options={servisTipiSecenekleri}
                                    value={filtreServisTipi}
                                    onChange={(event, value) => setFiltreServisTipi(value)}
                                    renderInput={(params) => <TextField {...params} label="Servis Tipi" />}
                                />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
                                <Autocomplete
                                    size="small"
                                    options={durumSecenekleri}
                                    value={filtreDurum}
                                    onChange={(event, value) => setFiltreDurum(value)}
                                    renderInput={(params) => <TextField {...params} label="Durum" />}
                                />
                            </Grid>
                            {filtreAktifMi && (
                                <Grid>
                                    <Button size="small" startIcon={<ClearIcon />} onClick={filtreleriTemizle}>
                                        Filtreleri Temizle
                                    </Button>
                                </Grid>
                            )}
                        </Grid>
                        <TableContainer sx={{ maxHeight: 560, overflow: 'auto' }}>
                            <Table stickyHeader aria-label="sticky table" size="small">
                                <TableHead style={{ overflowWrap: 'break-word' }}>
                                    <TableRow>
                                        <TableCell align="left">Açılış Tipi</TableCell>
                                        <TableCell align="left">Durum</TableCell>
                                        <TableCell align="left">İl-İlçe</TableCell>
                                        <TableCell align="left">Servis Tipi</TableCell>
                                        <TableCell align="left">Servis Bilgi</TableCell>
                                        <TableCell align="left">Açılış Detayı</TableCell>
                                        <TableCell align="left">Servis Konumu</TableCell>
                                        <TableCell align="left">Findeks Yorumu</TableCell>
                                        <TableCell align="left">Yorumlar</TableCell>
                                        <TableCell align="left">Belgeler</TableCell>
                                        <TableCell align="center" colSpan={2}>Süreç İşlemi</TableCell>
                                        <TableCell align="left" />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData?.length ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
                                        <TableRow key={row.ID ?? index}
                                            style={row.ID === selectedIndex ? { backgroundColor: "rgba(255, 152, 0, 0.16)" }
                                                : {}}
                                        >
                                            <TableCell align="left">{row.ACILIS_TIP}</TableCell>
                                            <TableCell align="left">{getDurumText(row)}</TableCell>
                                            <TableCell align="left">{row.IL_ILCE}</TableCell>
                                            <TableCell align="left">{row.SERVIS_TIP}</TableCell>
                                            <TableCell align="left">
                                                <ExpandableComment
                                                    Comment={row.SERVIS_BILGI}
                                                    CommentLimit={100}
                                                    DarkColor={selectedIndex != row.ID ? false : true} />
                                            </TableCell>
                                            <TableCell align="left">{row.ACILIS_TIP_ID == 1 ? '-' :
                                                row.ACILIS_TIP_ID == 2 ? <><b>Devir olan servis: </b> {row.DEVIR}</> :
                                                    row.ACILIS_TIP_ID == 3 ? <><b>Şirketleşen servis: </b> {row.SIRKETLESME}</> :
                                                        row.ACILIS_TIP_ID == 4 ? <><b>Birleşen servisler: </b> {row.BIRLESME}</> :
                                                            <><b>Şube Açan Servis: </b> {row.SUBELESME}</>}</TableCell>
                                            <TableCell align="left">{row.SERVIS_KONUMU}</TableCell>
                                            <TableCell align="left">{row.FINDEKS_YORUM}</TableCell>
                                            <TableCell align="left">
                                                <Tooltip title="Yorum Geçmişi">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleYorum(row)}
                                                        style={{ backgroundColor: '#19ecff', color: 'white' }}
                                                    >
                                                        <CommentOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Tooltip title="Belgeler">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleFilePopUp(row)}
                                                        style={{ backgroundColor: '#FF7F00', color: 'white' }}
                                                    >
                                                        <AttachFileOutlinedIcon />
                                                    </IconButton>
                                                </Tooltip>
                                            </TableCell>

                                            <TableCell align="left" colSpan={2} style={{ minWidth: 220 }}>
                                                {row.DURUM_ID == 1 ?
                                                    <Tooltip title="Bu açılış başvurusunu iptal eder">
                                                        <Button
                                                            size="small"
                                                            color="secondary"
                                                            onClick={() => handleCancelButtonClicked(row.ID, row.DURUM_ID)}
                                                            aria-label="İptal Et"
                                                            variant="contained"
                                                            endIcon={<BlockIcon />}
                                                            sx={styles.softDanger}
                                                            fullWidth
                                                        >
                                                            İptal Et
                                                        </Button>
                                                    </Tooltip>
                                                    : row.DURUM_ID == 5 ?
                                                        <Stack direction="row" spacing={1}>
                                                            <Tooltip title="Bu açılış başvurusunu iptal eder">
                                                                <Button
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={() => handleCancelButtonClicked(row.ID, row.DURUM_ID)}
                                                                    aria-label="İptal Et"
                                                                    variant="contained"
                                                                    endIcon={<BlockIcon />}
                                                                    sx={{ ...styles.softDanger, flex: 1 }}
                                                                >
                                                                    İptal Et
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Bu başvuruyu sürece tekrar dahil eder">
                                                                <Button
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={() => handleConfirmButtonClicked(row.ID, row.DURUM_ID)}
                                                                    aria-label="Devam Et"
                                                                    variant="contained"
                                                                    endIcon={<CheckCircleOutlineIcon />}
                                                                    sx={{ ...styles.softSuccess, flex: 1 }}
                                                                >
                                                                    Devam Et
                                                                </Button>
                                                            </Tooltip>
                                                        </Stack> :
                                                        <Stack direction="row" spacing={1}>
                                                            <Tooltip title="Bu başvuruyu reddedip bir önceki adıma geri gönderir">
                                                                <Button
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={() => handleRejectButtonClicked(row.ID, row.DURUM_ID)}
                                                                    aria-label="Reddet"
                                                                    variant="contained"
                                                                    endIcon={<BlockIcon />}
                                                                    sx={{ ...styles.softDanger, flex: 1 }}
                                                                >
                                                                    Reddet
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Bu başvuruyu sürece tekrar dahil eder">
                                                                <Button
                                                                    size="small"
                                                                    color="secondary"
                                                                    onClick={() => handleConfirmButtonClicked(row.ID, row.DURUM_ID)}
                                                                    aria-label="Devam Et"
                                                                    variant="contained"
                                                                    endIcon={<CheckCircleOutlineIcon />}
                                                                    sx={{ ...styles.softSuccess, flex: 1 }}
                                                                >
                                                                    Devam Et
                                                                </Button>
                                                            </Tooltip>
                                                        </Stack>
                                                }
                                            </TableCell>

                                        </TableRow>
                                    )) : (
                                        <TableRow>
                                            <TableCell colSpan={12} align="center" style={{ padding: 32 }}>
                                                {generalData.length
                                                    ? 'Filtrelere uyan kayıt bulunamadı.'
                                                    : (loading ? 'Kayıtlar yükleniyor...' : 'Reddedilen kayıt bulunmamaktadır.')}
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <TablePagination
                            component="div"
                            count={filteredData.length}
                            page={page}
                            onPageChange={(event, newPage) => setPage(newPage)}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={(event) => {
                                setRowsPerPage(parseInt(event.target.value, 10));
                                setPage(0);
                            }}
                            rowsPerPageOptions={[10, 25, 50, 100]}
                            labelRowsPerPage="Sayfa başı kayıt:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} / ${count}`}
                        />
                    </CardContent>
                    <Dialog
                        open={tarihcePopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={event => setTarihcePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Yorum Geçmişi</DialogTitle>
                        <DialogContent>
                            <Tarihce BasvuruId={selectedIndex} readonly={false} OpenClose={1} />
                        </DialogContent>
                        <DialogActions>
                            <IconButton
                                color="primary"
                                onClick={event => setTarihcePopUp(false)}
                                aria-label="upload picture"
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={filePopUp}
                        onClose={() => setFilePopUp(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        PaperProps={{
                            sx: {
                                width: 480,
                                height: 560,
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                display: 'flex',
                                flexDirection: 'column'
                            }
                        }}
                    >
                        <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                            {`Belgeler${fileList?.length ? ` (${fileList.length})` : ''}`}
                            <IconButton
                                onClick={() => setFilePopUp(false)}
                                aria-label="close"
                                sx={styles.closeButton}
                                component="span"
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <Divider />
                        <DialogContent sx={{ p: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                            {fileList?.length ? (
                                <List sx={{ flex: 1, overflow: 'auto', py: 0 }}>
                                    {fileList.map((item, index) => (
                                        <React.Fragment key={item.DOSYA_ID}>
                                            {index > 0 && <Divider component="li" />}
                                            <ListItem disablePadding>
                                                <ListItemButton onClick={() => setNewWindowOpen(item)}>
                                                    <ListItemIcon>
                                                        <InsertDriveFileOutlinedIcon style={{ color: '#FF9800' }} />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={item.DOSYA_ADI}
                                                        secondary={item.ContentType}
                                                    />
                                                </ListItemButton>
                                            </ListItem>
                                        </React.Fragment>
                                    ))}
                                </List>
                            ) : (
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, color: 'text.secondary' }}>
                                    {loading ? (
                                        <>
                                            <CircularProgress size={28} />
                                            <Typography variant="body2">Dosyalar yükleniyor...</Typography>
                                        </>
                                    ) : (
                                        <>
                                            <FolderIcon fontSize="large" />
                                            <Typography variant="body2">Dosya bulunmamaktadır.</Typography>
                                        </>
                                    )}
                                </Box>
                            )}
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <Button
                                onClick={() => setFilePopUp(false)}
                                color="secondary"
                                variant="contained"
                            >
                                Kapat
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Card>
            </Container>
        </Page>
    );
}
export default OpenReject;
